import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import MessageBox from 'Components/Utility/MessageBox';

const messages = defineMessages({
  refresh: { id: 'steam-success.refresh', defaultMessage: 'Steam account refreshed' },
  connect: { id: 'steam-success.connect', defaultMessage: 'Steam account connected' },
  disconnect: { id: 'steam-success.disconnect', defaultMessage: 'Steam account disconnected' },
  settings: { id: 'steam-success.settings', defaultMessage: 'Steam sync settings updated' },
  sync: { id: 'steam-success.sync', defaultMessage: 'Steam synced successfully' },
});

const SteamSuccess = ({ type, closeFunction, intl }) => {
  if (!type) {
    return false;
  }

  const { formatMessage } = intl;

  let message = formatMessage(messages.connect);

  if (messages[type]) {
    message = formatMessage(messages[type]);
  }

  return (
    <MessageBox
      dismissible
      message={message}
      type="success"
      closeFunction={closeFunction}
    />
  );
};

export default injectIntl(SteamSuccess);

SteamSuccess.propTypes = {
  type: PropTypes.string,
  closeFunction: PropTypes.func,
};

SteamSuccess.defaultProps = {
  type: null,
};
